import Box from '@mui/joy/Box'

export const SchemaRoute = () => {
  return <Box>SchemaRoute</Box>
}
